import { areaData } from "../../../../AverageCareHomeCosts/AverageCareHomeCosts"
import { formatNumberAsGbp } from "../../../../AverageCareHomeCosts/PricePerWeek/PricePerWeek"

const getRegionFromBranchRecords = (branchRecord) =>
  branchRecord.address.constituentCountry === "Scotland"
    ? branchRecord.address.constituentCountry
    : branchRecord.address.region

// eslint-disable-next-line import/prefer-default-export
export const averageCareHomeCostAnswer = (branchRecords, locationName) => {
  const regionName = getRegionFromBranchRecords(branchRecords[0])
  const regionData = areaData[regionName]

  if (!regionData) {
    return ""
  }

  const pricesFromBranchRecords = branchRecords
    .filter((br) => br.careProvider && br.careProvider.chStartingWeeklyRate > 0)
    .map((br) => br.careProvider.chStartingWeeklyRate)

  const lowestPriceFromBranchRecords =
    pricesFromBranchRecords.length > 0
      ? Math.min.apply(null, pricesFromBranchRecords)
      : 0

  const lowestPriceText =
    lowestPriceFromBranchRecords > 0
      ? ` From the care homes in ${locationName} who share their prices with us, we can see care home prices starting from ${formatNumberAsGbp(
          lowestPriceFromBranchRecords,
        )} per week.`
      : ""

  return `On average residential care homes in ${regionName} cost 
  ${formatNumberAsGbp(
    regionData.residential,
  )} per week, with nursing homes costing on average
  ${formatNumberAsGbp(regionData.nursing)} per week.${lowestPriceText}`
}
